
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
// Updated import: Replaced Backup with DatabaseBackup
import { DatabaseBackup, FileText, History, Combine, Zap, ShieldCheck, ExternalLink } from "lucide-react"; 

const featureItems = [
  {
    // Updated icon: Replaced Backup with DatabaseBackup
    icon: <DatabaseBackup className="w-12 h-12 text-primary mb-4" />,
    title: "Automated Backups",
    description: "Never worry about losing your forms. Our system automatically backs up your form structures and associated configuration at regular intervals, ensuring everything is safe and sound.",
    imageSrc: "https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Automated backup system visualization",
  },
  {
    icon: <ShieldCheck className="w-12 h-12 text-primary mb-4" />,
    title: "Secure Storage",
    description: "Your valuable form configuration and structures (field definitions, layout, characteristics, connections, and themes, etc) are encrypted and stored securely, protected from loss and unauthorized access, ensuring compliance and peace of mind.",
    imageSrc: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80", // Generic security image
    imageAlt: "Secure data storage illustration",
  },
  {
    icon: <History className="w-12 h-12 text-primary mb-4" />,
    title: "Trigger manual backups for large changes",
    description: "Keep a personal handle on forms that need a little extra backup when doing major revisions.",
    imageSrc: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Version history tracking interface",
  },
    {
    icon: <Zap className="w-12 h-12 text-primary mb-4" />, // Using Zap as placeholder for Restore
    title: "Easy Restore",
    description: "Quickly restore any backed-up version of your forms with just a few clicks. Minimize downtime and recover corrupted, accidentally deleted or modified forms effortlessly.",
    imageSrc: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Form restoration interface",
  },
  {
    icon: <ExternalLink className="w-12 h-12 text-primary mb-4" />,
    title: "Data Portability & Integrations",
    description: "Easily export your form metadata and structures. Prepare your data for migration to other systems or integrate with your existing analytics and reporting tools.",
    imageSrc: "https://images.unsplash.com/photo-1473091534298-04dcbce3278c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Data integration and export options",
  },
];

const FeaturesPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-grow py-12 md:py-20">
        <div className="container mx-auto px-6">
          <header className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground">
              Powerful Features to Protect Your Forms
            </h1>
            <p className="text-lg text-muted-foreground mt-4 max-w-2xl mx-auto">
              Discover how FAB (Forms And Backup) provides comprehensive tools to safeguard and manage your critical form assets.
            </p>
          </header>

          <div className="grid gap-12">
            {featureItems.map((feature, index) => (
              <Card 
                key={feature.title} 
                className={`overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 ${index % 2 === 0 ? '' : 'bg-muted/50'}`}
              >
                <div className={`grid md:grid-cols-2 items-center`}>
                  <div className={`p-8 md:p-12 ${index % 2 === 0 ? 'md:order-1' : 'md:order-2'}`}>
                    <div className="flex items-center mb-4 flex-wrap gap-2">
                      {feature.icon}
                      <CardTitle className="text-2xl md:text-3xl font-semibold text-foreground">{feature.title}</CardTitle>
                    </div>
                    <CardContent className="p-0">
                      <p className="text-muted-foreground text-lg leading-relaxed">{feature.description}</p>
                    </CardContent>
                  </div>
                  <div className={`${index % 2 === 0 ? 'md:order-2' : 'md:order-1'}`}>
                    <img 
                      src={feature.imageSrc} 
                      alt={feature.imageAlt} 
                      className="w-full h-64 md:h-96 object-cover" 
                    />
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default FeaturesPage;
